/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_Offline_BodyInputs */

const en_recipe_offline_body = /** @type {(inputs: Recipe_Offline_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open it once while online to keep it on this device.`)
};

const de_recipe_offline_body = /** @type {(inputs: Recipe_Offline_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffne es einmal online, damit es auf diesem Gerät bleibt.`)
};

/**
* | output |
* | --- |
* | "Open it once while online to keep it on this device." |
*
* @param {Recipe_Offline_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_offline_body = /** @type {((inputs?: Recipe_Offline_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_Offline_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_offline_body(inputs)
	return en_recipe_offline_body(inputs)
});